module.exports = __webpack_public_path__ + "img/App_Store.74c7f2f1.svg";